import { Component, OnInit } from '@angular/core';
import { AuthService } from '../providers/auth.service';
import { Router } from '@angular/router';
import {Subject, Observable, BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(public authService: AuthService, private router: Router) { }

  ngOnInit() {
  }

  public email = '';
  public password = '';

  login() {
    
    this.authService.loginWithEmail(this.email, this.password).then((daa: Observable<boolean>) => {

      daa.subscribe((ee:boolean)=> {
        if(ee)
        {
     
          this.router.navigate(['dashboard']);
        }
        else{
         
          this.authService.logout();
        }
      });
    });
  }

}
